import LoginPage from "views/Pages/LoginPage.js";
import RegisterPage from "views/Pages/RegisterPage.js";
import UserProfile from "views/Pages/UserProfile.js";

import ForgetPasswordPage from "views/Pages/ForgetPassword.js";
import GHDashboard from "views/Dashboard/GHdashboard.js";
import Survey from "views/GHBank/Survey.js";
import Report from "views/GHBank/Report.js";
import FAQ from "views/GHBank/FAQ.js";
import Manual from "views/GHBank/Manual.js";
import Contact from "views/GHBank/Contact.js";
import NewPasswordPage from "views/Pages/NewPassword.js";

import Home from "@material-ui/icons/Home";
import WebAsset from "@material-ui/icons/WebAsset";
import Equalizer from "@material-ui/icons/Equalizer";
import ContactSupport from "@material-ui/icons/ContactSupport";
import CollectionsBookmark from "@material-ui/icons/CollectionsBookmark";
import PermPhoneMsg from "@material-ui/icons/PermPhoneMsg";
import Image from "@material-ui/icons/Image";

var dashRoutes = [
  {
    path: "/dashboard",
    name: "Dashboard",
    rtlName: "لوحة القيادة",
    thName: "หน้าหลัก",
    icon: Home,
    component: GHDashboard,
    layout: ""
  },
  {
    path: "/survey",
    name: "Survey",
    rtlName: "لوحة القيادة",
    thName: "แบบสอบถาม",
    icon: WebAsset,
    component: Survey,
    layout: ""
  },
  {
    path: "/report",
    name: "Report",
    rtlName: "لوحة القيادة",
    thName: "รายงาน",
    icon: Equalizer,
    component: Report,
    layout: ""
  },
  {
    path: "/faq",
    name: "FAQ",
    rtlName: "لوحة القيادة",
    thName: "คำถามที่พบบ่อย",
    icon: ContactSupport,
    component: FAQ,
    layout: ""
  },
  {
    path: "/manual",
    name: "Manual",
    rtlName: "لوحة القيادة",
    thName: "คู่มือการใช้งาน",
    icon: CollectionsBookmark,
    component: Manual,
    layout: ""
  },
  {
    path: "/contact",
    name: "Contact",
    rtlName: "لوحة القيادة",
    thName: "ติดต่อเรา",
    icon: PermPhoneMsg,
    component: Contact,
    layout: ""
  },
  {
    path: "/user-page",
    name: "User Profile",
    rtlName: "ملف تعريفي للمستخدم",
    thName: "ข้อมูลผู้ใช้งาน",
    mini: "UP",
    rtlMini: "شع",
    component: UserProfile,
    layout: "",
    invisible: true
  },
  {
    collapse: true,
    name: "Pages",
    rtlName: "صفحات",
    icon: Image,
    state: "pageCollapse",
    invisible: true,
    views: [
      {
        path: "/login-page",
        name: "Login Page",
        rtlName: "هعذاتسجيل الدخول",
        mini: "L",
        rtlMini: "هعذا",
        component: LoginPage,
        layout: "/auth"
      },
      {
        path: "/register-page",
        name: "Register Page",
        rtlName: "تسجيل",
        mini: "R",
        rtlMini: "صع",
        component: RegisterPage,
        layout: "/auth"
      },
      {
        path: "/reset-page",
        name: "Reset password Page",
        rtlName: "صفحة الخطأ",
        mini: "E",
        rtlMini: "البريد",
        component: ForgetPasswordPage,
        layout: "/auth"
      },
      {
        path: "/",
        name: "Reset password Page",
        rtlName: "صفحة الخطأ",
        mini: "E",
        rtlMini: "البريد",
        component: NewPasswordPage,
        layout: "/reset",
        invisible: true
      }
    ]
  }
];
export default dashRoutes;
